import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CollaborationReason, CollaborationReasonInput} from './collaboration-reason.model';

export const loadCollaborationReasons = createAction(
  '[CollaborationReason/API] Load CollaborationReasons',
  props<{ collaborationReasons: CollaborationReason[] }>()
);

export const addCollaborationReason = createAction(
  '[CollaborationReason/API] Add CollaborationReason',
  props<{ collaborationReason: CollaborationReason }>()
);

export const upsertCollaborationReason = createAction(
  '[CollaborationReason/API] Upsert CollaborationReason',
  props<{ collaborationReason: CollaborationReason }>()
);

export const addCollaborationReasons = createAction(
  '[CollaborationReason/API] Add CollaborationReasons',
  props<{ collaborationReasons: CollaborationReason[] }>()
);

export const upsertCollaborationReasons = createAction(
  '[CollaborationReason/API] Upsert CollaborationReasons',
  props<{ collaborationReasons: CollaborationReason[] }>()
);

export const updateCollaborationReason = createAction(
  '[CollaborationReason/API] Update CollaborationReason',
  props<{ collaborationReason: Update<CollaborationReason> }>()
);

export const updateCollaborationReasons = createAction(
  '[CollaborationReason/API] Update CollaborationReasons',
  props<{ collaborationReasons: Update<CollaborationReason>[] }>()
);

export const deleteCollaborationReason = createAction(
  '[CollaborationReason/API] Delete CollaborationReason',
  props<{ id: string }>()
);

export const deleteCollaborationReasons = createAction(
  '[CollaborationReason/API] Delete CollaborationReasons',
  props<{ ids: string[] }>()
);

export const clearCollaborationReasons = createAction(
  '[CollaborationReason/API] Clear CollaborationReasons'
);

// CUSTOM ACTIONS
export const createCollaborationReasonMutation = createAction(
  '[CollaborationReason/API] Create CollaborationReason',
  props<{ input: CollaborationReasonInput }>()
);

export const updateCollaborationReasonMutation = createAction(
  '[CollaborationReason/API] update CollaborationReason',
  props<{ input: CollaborationReasonInput }>()
);

export const getAllCollaborationReasons = createAction(
  '[CollaborationReason/API] Get all CollaborationReasons'
);

export const removeCollaborationReason = createAction(
  '[CollaborationReason/API] remove CollaborationReason',
  props<{ uniqueId?: string; id?: string; }>()
);
